import { render, staticRenderFns } from "./emails.vue?vue&type=template&id=a22176bc"
import script from "./emails.vue?vue&type=script&lang=ts"
export * from "./emails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports